import "./svg/refresh.svg"

export default {
    name: "refresh",
    viewBox: "20 20",
}
